import { supabase } from '../supabase';

export type MfaGate = 'checking' | 'enroll' | 'challenge' | 'passed';

/** Resolve o estado MFA da sessão atual (AAL1 → enroll/challenge, AAL2 → passed). */
export async function resolveMfaGate(): Promise<MfaGate> {
    if (import.meta.env.VITE_MFA_REQUIRED !== 'true') return 'passed';

    const { data: aal, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
    if (error || !aal) return 'passed';

    if (aal.currentLevel === 'aal2') return 'passed';
    if (aal.nextLevel !== 'aal2') return 'passed';

    const { data: factors } = await supabase.auth.mfa.listFactors();
    const hasFactor = (factors?.totp?.length ?? 0) > 0;
    return hasFactor ? 'challenge' : 'enroll';
}

export function mfaPathForGate(gate: MfaGate): string | null {
    if (gate === 'enroll') return '/auth/mfa-enroll';
    if (gate === 'challenge') return '/auth/mfa-challenge';
    return null;
}
